<template>
  <div>
    <v-card>
      <v-card>
        <v-toolbar dark>

          <v-toolbar-title>{{ $t('reports.headers.alerts') }}</v-toolbar-title>

        </v-toolbar>

        <v-subheader>{{ alert.name }}</v-subheader>
        <v-card-text>
          {{ alert.description }}
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'show-alert',
    props: {
      alert: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatNumber(number) {
        if(typeof number === 'undefined' || !number) {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/reports/show_alert.vue